import {
  RefreshOnboardingLinkPayload,
  StartBankOnboardingPayload,
  StripeAchPayout,
  StripeConnectAccountStatus,
  StripeConnectOnboardingLink,
} from '@/models/stripeConnectModels';

import { api } from '../api';

const urls = {
  status: () => '/payments/stripe-connect/status/',
  payouts: () => '/payments/stripe-connect/payouts/',
  startOnboarding: () => '/payments/stripe-connect/',
  onboardingLink: (accountId: number) => `/payments/stripe-connect/${accountId}/onboarding-link/`,
};

export const getStripeConnectStatus = async (affiliate_uid: number): Promise<StripeConnectAccountStatus> => {
  return api.get<StripeConnectAccountStatus>(urls.status(), {
    params: { affiliate_uid },
  });
};

export const getStripeConnectPayouts = async (affiliate_uid: number): Promise<StripeAchPayout[]> => {
  return api.get<StripeAchPayout[]>(urls.payouts(), {
    params: { affiliate_uid },
  });
};

export const startBankOnboarding = async ({
  affiliate_uid,
  return_host,
}: StartBankOnboardingPayload): Promise<StripeConnectOnboardingLink> => {
  return api.post<StripeConnectOnboardingLink>(urls.startOnboarding(), { affiliate_uid, return_host });
};

export const refreshOnboardingLink = async ({
  account_id,
  return_host,
}: RefreshOnboardingLinkPayload): Promise<StripeConnectOnboardingLink> => {
  return api.post<StripeConnectOnboardingLink>(urls.onboardingLink(account_id), { return_host });
};
